import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

export const Route = createFileRoute("/auth/callback")({
  component: AuthCallback,
});

function AuthCallback() {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      globalThis.location.replace("/dashboard");
    }
  }, [auth.isLoading, auth.isAuthenticated]);

  return (
    <div className="loading-screen">
      <output className="loading-mark" aria-label="Signing in…" />
    </div>
  );
}
